// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"837c06ac","787":"5751b591"}[chunkId] + ".chunk.js";
};